<script>

export default {
    name: 'Parte2',
    data(){
    return{
      num: 1000,      
    }
  }
}
document.addEventListener('scroll', function () {
    const elements = document.querySelectorAll('.element');

    elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
            const num = 1000 ;
            setTimeout(() => {
                element.classList.add('visible');
            }, num); // Atraso de 1 segundo
        }
    });
});
document.addEventListener('scroll', function () {
    const elements = document.querySelectorAll('.titulo3');

    elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
            setTimeout(() => {
                element.classList.add('visible');
            }, 1000); // Atraso de 1 segundo
        }
    });
});

</script>

<template>
    <div class="main">

        <div class="bloco1">
            <div class="bloco2">
                <p class="titulo">O QUE NOS MOVE</p>
            </div>
            <div class="bloco3">

                <div class="visao">
                    <p class="titulo3">Visão</p>
                    <p class="element">Ser reconhecida por soluções diferenciadas na execução de Serviços Industriais em
                        Fabricação de
                        Estruturas Metálicas, Usinagem de Precisão e Montagens Industriais.</p>
                </div>

                <div class="missao">
                    <p class="titulo3">Missão</p>
                    <p class="element">Desenvolver soluções diferenciadas, garantindo a melhoria contínua através de boas
                        práticas de
                        Serviços Industriais em Fabricação de Estruturas Metálicas, Usinagem de Precisão e Montagens
                        Industriais, desenvolvendo pessoas, crescendo de forma sustentável e agregando valor para os
                        envolvidos no negócio.</p>
                </div>
                <div class="valores">
                    <p class="titulo3">Valores</p>
                    <div class="element">
                        <p class="">- Inovação promovendo o incentivo à criatividade e a busca ao conhecimento;</p>
                        <p class="">- Qualidade no atendimento ágil e na execução dos serviços prestados;</p>
                        <p class="">- Ética nos relacionamentos e no cumprimento dos princípios legais;</p>
                        <p class="">- Pessoas respeitadas, comprometidas e realizadas;</p>
                        <p class="">- Segurança através da preservação da vida como valor fundamental;</p>
                        <p class="">- Responsabilidade Socioambiental pensando nos negócios da empresa e seus impactos
                            de forma
                            sustentável.</p>
                    </div>
                </div>

            </div>

        </div>


    </div>
</template>

<style scoped>
@media (max-width: 900px) {
.main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 100vw;
    color: #f3f3f3;
}

.bloco1 {
    background:
        linear-gradient(#000000d7, #000000d7),
        /* Gradiente escuro semi-transparente */
        url('../assets/imagens/etica.webp');
    /* Imagem de fundo */
    background-size: cover;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat: no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.bloco2 {
    height: 15%;
}

.bloco3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1%;
}

.visao {
    width: 100%;
    padding: 1%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2%;
}

.missao {
    width: 100%;
    padding: 1%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2%;
}

.valores {
    width: 100%;
    padding: 1%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}


.titulo3 {
    
}

.text {
    color: #e2e2e2;
    text-align: justify;
    width: 70%;

}

.titulo {
    font-size: 1.5rem;
    font-weight: 600;
    color: #f3f3f3ee;
    padding: 0.7rem;
    border-radius: 10px;
    border: 2px solid #2431e6;
}

.text_valores {
    display: flex;
    flex-direction: column;
    width: 70%;
    gap: 2px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.element {
    opacity: 0;
    /* Elemento inicialmente invisível */
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    color: #e2e2e2;
    text-align: justify;
    width: 95%;
}

.element.visible {
    animation: fadeIn 0.5s forwards;
    /* Animação de 0.5s quando o elemento está visível */
}
.titulo3 {
    opacity: 0;
    /* Elemento inicialmente invisível */
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 1px;
    width: 30%;
    text-align: center;
}

.titulo3.visible {
    animation: fadeIn 0.5s forwards;
    /* Animação de 0.5s quando o elemento está visível */
}
}
@media (min-width: 901px) {
.main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 100vw;
    color: #f3f3f3;
}

.bloco1 {
    background:
        linear-gradient(#000000d7, #000000d7),
        /* Gradiente escuro semi-transparente */
        url('../assets/imagens/etica.webp');
    /* Imagem de fundo */
    background-size: cover;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat: no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.bloco2 {
    height: 15%;
}

.bloco3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1%;
}

.visao {
    width: 30%;
    padding: 1%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 80%;
    margin-bottom: 2%;
}

.missao {
    width: 30%;
    padding: 1%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 80%;
    margin-bottom: 2%;
}

.valores {
    width: 80%;
    padding: 1%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 80%;
}


.titulo3 {
    
}

.text {
    color: #e2e2e2;
    text-align: justify;
    width: 70%;

}

.titulo {
    font-size: 2rem;
    font-weight: 600;
    color: #f3f3f3ee;
    border: 2px solid #2431e6;
    padding: 0.7rem;
    border-radius: 10px;
}

.text_valores {
    display: flex;
    flex-direction: column;
    width: 70%;
    gap: 2px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.element {
    opacity: 0;
    /* Elemento inicialmente invisível */
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    color: #e2e2e2;
    text-align: justify;
    width: 70%;
}

.element.visible {
    animation: fadeIn 0.5s forwards;
    /* Animação de 0.5s quando o elemento está visível */
}
.titulo3 {
    opacity: 0;
    /* Elemento inicialmente invisível */
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 1px;
    width: 30%;
    text-align: center;
}

.titulo3.visible {
    animation: fadeIn 0.5s forwards;
    /* Animação de 0.5s quando o elemento está visível */
}
}
</style>